import { useParams } from 'react-router-dom';

export const useMissionRouteParams = () => {
  const { missionSlug, chapterTitle } = useParams<{ missionSlug: string; chapterTitle: string }>();

  return { missionSlug, chapterTitle, chapterTitleEncoded: encodeURIComponent(chapterTitle || '') };
};
